export interface MapItem {
  label: string;
  value?: any;
  url?: string;
  key?: string;
}
